const SDK_VERSION = '8.8.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
